import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'franbase-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private titleSV: Title) {
    this.titleSV.setTitle('Franbase Frontend');
  }
}
